<script>
    import { Router, Link, Route, navigate } from "svelte-routing";
    import Home from "./pages/Home.svelte";
    import Blog from "./pages/Blog.svelte";
    import About from "./pages/About.svelte";
    import Financer from "./pages/Financer.svelte";

    let darkModeEnabled = localStorage.theme === "dark";
    export let url = "";

    function sendHome() {
        navigate("/qubyts", { replace: true });
    }

    function toggleDark() {
        if (localStorage.theme === "dark") localStorage.theme = "light";
        else localStorage.theme = "dark";
        document.documentElement.classList.toggle("dark");
        darkModeEnabled = !darkModeEnabled;
    }
</script>

<Router basepath="/qubyts" {url}>
    <main class="flex flex-col lg:mx-28 transition-colors">
        <div
            class="flex md:flex-row flex-col items-center justify-center md:justify-evenly"
        >
            <div on:click={sendHome}>
                <h3
                    class="p-2 text-2xl font-bold text-black rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 hover:cursor-pointer dark:text-white"
                >
                    Qubyt's Blog
                </h3>
            </div>
            <div>
                <nav
                    class="flex flex-col justify-center items-center md:flex-row"
                >
                    <Link
                        to="/qubyts/blog"
                        class="px-6 mx-2 py-2 text-xl font-bold text-black cursor-pointer dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600 focus:bg-gray-200 dark:focus:bg-gray-600 rounded-md"
                        >Blog</Link
                    >
                    <Link
                        to="/qubyts/about"
                        class="px-6 mx-2 py-2 text-xl font-bold text-black cursor-pointer dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600 focus:bg-gray-200 dark:focus:bg-gray-600 rounded-md"
                        >About</Link
                    >
                    <Link
                        to="/qubyts/financer"
                        class="px-6 mx-2 py-2 text-xl font-bold text-black cursor-pointer dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600 focus:bg-gray-200 dark:focus:bg-gray-600 rounded-md"
                        >Financer</Link
                    >
                </nav>
            </div>
            <label class="relative flex items-center justify-center p-2 group">
                <input
                    type="checkbox"
                    on:click={toggleDark}
                    bind:checked={darkModeEnabled}
                    class="absolute w-full h-full appearance-none left-1/2 -translate-x-1/2 peer rounded-md"
                />
                <span
                    class="flex items-center flex-shrink-0 w-10 h-6 p-1 bg-gray-300 rounded-full duration-300 ease-in-out peer-checked:bg-gray-500 after:w-4 after:h-4 after:bg-white after:rounded-full after:shadow-md after:duration-300 peer-checked:after:translate-x-4 group-hover:after:translate-x-1"
                />
            </label>
        </div>

        <div class="h-5 w-full" />
        <div>
            <Route path="" component={Home} />
            <Route path="blog" component={Blog} />
            <Route path="financer" component={Financer} />
            <Route path="about" component={About} />
        </div>
    </main>
</Router>
